import React, { lazy, Suspense, useEffect, useMemo, useState } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import PageLoader from '@/components/PageLoader';
import { routesConfig } from './RoutesConfig';
import URL from '@/pages/URL';
import { useSelector } from 'react-redux';
import { selectCurrentAdmin } from '@/redux/auth/selectors';
import AnnouncementBanner from '@/components/anncoument/AnnoucmentBanner';
import ShiftManagementApp from '@/components/attendance/ShiftEndModal';
import axios from 'axios';
import moment from 'moment';
import { message, Spin } from 'antd';
import { resetLocalStorageAfterAttendance } from '@/utils/attendanceUtils';
import GenerateEnergySound from '@/pages/GenerateEnergySound';
import { useDispatch } from "react-redux";
import { markOut } from '../redux/screenShorts/screenShortSaveSlice';
import { useLocalStorage } from 'react-use';
import ResetPasswordScreen from '@/pages/ResetPasswordScreen';
import { filterRoutesByBackendPermissions } from '@/utils/filterRoutesByBackendPermissions';
const Logout = lazy(() => import(/*webpackChunkName:'LogoutPage'*/ '@/pages/Logout'));
const NotFound = lazy(() => import(/*webpackChunkName:'NotFoundPage'*/ '@/pages/NotFound'));

const SubMenuRouter = ({ subMenuRouter }) => {
  subMenuRouter.map((subMenu) => {

    return (
      <PrivateRoute
        key={subMenu.component}
        path={subMenu.path}
        exact={subMenu.exact || true}
        component={lazy(() =>
          import(/* webpackChunkName: "[request]" */ `@/pages/${subMenu.component}`)
        )}
      />
    );
  });
};

export default function AppRouter() {
  const location = useLocation();
  const currentAdmin = useSelector(selectCurrentAdmin); // Selector to fetch current admin
  const [overTime, setOverTime] = useState(false);
  const [timeIn, setTimeIn] = useState(localStorage.getItem("timeIn"));
  const [timeOut, setTimeOut] = useState(localStorage.getItem("timeOut")); // ✅ now state
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const dispatch = useDispatch();
  const [attendanceStatus, setAttendanceStatus] = useState(localStorage.getItem("attendanceStatus"));
  const userRole = currentAdmin?.role || 'Employee';
  // const isSuperAdmin = userRole === 'super-admin' || currentAdmin?._id === '6591d11aabbe63958da9a7f2' || currentAdmin?._id === '64ec6adc9c3ccb46c000dc14';
  const isSuperAdmin = userRole === 'super_admin';
  // let rolePermissions = useSelector(state => {
  //   return state.rolePermissions.entities
  // })
  const [loading, setLoading] = useState(false);



  
  // ✅ NEW:
  const filteredRoutes = filterRoutesByBackendPermissions(
    routesConfig,
    currentAdmin.permissions, // Pass permissions directly from login response
    currentAdmin.roleInfo      // Pass roleInfo directly from login response
  );
  
  
  useEffect(() => {
    const checkStatus = () => {
      const storedStatus = localStorage.getItem("attendanceStatus");
      setAttendanceStatus(storedStatus);
    };

    // Initial check
    checkStatus();

    // Poll every few seconds
    const interval = setInterval(checkStatus, 3000);

    // Or: listen to storage events from other tabs
    window.addEventListener("storage", checkStatus);

    return () => {
      clearInterval(interval);
      window.removeEventListener("storage", checkStatus);
    };
  }, []);

  const handleMarkOut = async () => {
    dispatch(markOut()); // 🚀 Uploads + resets session
  };

 
  const parseDurationString = (durationString) => {

    if (!durationString) return 0;
    const [hoursStr, minutesStr] = durationString.split('h');
    const hours = parseInt(hoursStr) || 0;
    const minutes = parseInt(minutesStr) || 0;
    return hours * 60 * 60 * 1000 + minutes * 60 * 1000;
  };
  // Save task history log to localStorage
  function saveTaskHistoryLog(description, logEntry) {
    const history = JSON.parse(localStorage.getItem('taskTimeHistory') || '{}');
    if (!history[description]) history[description] = [];
    history[description].push(logEntry);
    localStorage.setItem('taskTimeHistory', JSON.stringify(history));
  }
  const updateEffortTimeInAsanaTasks = async (index, formattedTotalDuration, dailyTask) => {
    try {

      let { data } = await axios.post("/asana-tasks-effort-time-update", { task: { ...dailyTask[index], duration: formattedTotalDuration } })
    } catch (error) {
      console.error(error, 'error for efforTime');

    }
  }

  function handleTaskEnd(index) {
    const dailyTask = JSON.parse(localStorage.getItem('dailyTask') || '[]');
    const runningTasks = JSON.parse(localStorage.getItem('runningTasks') || '[]');
    const endTime = new Date();
    const task = dailyTask[index];

    if (!task || !task.startTime) {
      console.error(`Start time missing for task ${index}`);
      return dailyTask;
    }

    const startTime = new Date(task.startTime);
    if (isNaN(startTime.getTime())) {
      console.error(`Invalid start time format for task ${index}`);
      return dailyTask;
    }

    localStorage.removeItem(`task${index}StartTime`);

    // Calculate duration
    const durationInMilliseconds = endTime - startTime;
    const currentDurationMs = parseDurationString(task.duration);
    const totalDurationMs = currentDurationMs + durationInMilliseconds;
    const totalHours = Math.floor(totalDurationMs / (1000 * 60 * 60));
    const totalMinutes = Math.floor((totalDurationMs % (1000 * 60 * 60)) / (1000 * 60));
    const formattedTotalDuration = `${totalHours}h ${totalMinutes}m`;

    // Update task
    dailyTask[index] = {
      ...task,
      isActive: false,
      endTime: endTime.toISOString(),
      duration: formattedTotalDuration,
    };

    // Update running tasks
    const updatedRunningTasks = runningTasks.filter((i) => i !== index);
    localStorage.setItem('runningTasks', JSON.stringify(updatedRunningTasks));
    localStorage.setItem('dailyTask', JSON.stringify(dailyTask));

    // Update button states
    const updatedStates = dailyTask.map(() => ({ start: true, end: false }));
    localStorage.setItem('taskButtonStates', JSON.stringify(updatedStates));

    // Save history
    saveTaskHistoryLog(task.description, {
      description: task.description,
      startTime: startTime.toISOString(),
      endTime: endTime.toISOString(),
      duration: formattedTotalDuration,
    });

    // Update Asana if needed
    if (task.taskGid) {
      updateEffortTimeInAsanaTasks(index, formattedTotalDuration, dailyTask);
    }

    return dailyTask;
  }

  function ConfirmTimeOut(overtime) {
    // Get all required data from localStorage
    const runningTasks = JSON.parse(localStorage.getItem('runningTasks') || '[]');
    const dailyTask = JSON.parse(localStorage.getItem('dailyTask') || '[]');
    const parsedTimeHistory = JSON.parse(localStorage.getItem('taskTimeHistory') || '{}');
    const tomorrowTask = JSON.parse(localStorage.getItem('tomorrowTask') || '[]');
    const notesList = JSON.parse(localStorage.getItem('notesList') || '[]');
    const notes = JSON.parse(localStorage.getItem('notes') || '[]');
    const overtTime = localStorage.getItem('overtTime');
    const attendanceTimeIn = localStorage.getItem('timeIn');
    // ✅ Get start time from localStorage
    const breakStartTime = new Date(localStorage.getItem("breakStartTime"));

    // ✅ Get end time (from server or current time)
    const breakEndTime = new Date(localStorage.getItem("breakEndTime"));

    // ✅ Calculate difference in seconds (to 3 decimal places)
    const breakTime = ((breakEndTime - breakStartTime) / 1000).toFixed(3);

    console.log(`Break duration: ${breakTime} seconds`);
    let updatedDailyTasks = dailyTask;
    // If overtime, end running task

    if (overtime && runningTasks.length > 0) {
      let result = runningTasks?.length ? handleTaskEnd(runningTasks[0]) : [];
      updatedDailyTasks = result.filter((task) => task?.startTime || task.startTime === null);

    }

    // Attach history to each task
    updatedDailyTasks = updatedDailyTasks.map((task) => ({
      ...task,
      taskHistory: parsedTimeHistory[task.description] || [],
    }));

    // Set timeOut
    const newTimeOut = moment();
    localStorage.setItem('timeOut', newTimeOut.toISOString());

    // Calculate elapsed time
    const duration = moment.duration(newTimeOut.diff(moment(attendanceTimeIn)));
    const hours = Math.floor(duration.asHours());
    const minutes = Math.floor(duration.asMinutes()) % 60;
    localStorage.setItem('elapsedTime', `${hours}h ${minutes}m`);
    localStorage.setItem('attendanceStatus', 'out');

    // Play audio
    const audio = new Audio('/livechat-129007.mp3');
    audio.play();

    // Send attendance to backend
    axios
      .post('/attendance', {
        timeIn: attendanceTimeIn,
        timeOut: newTimeOut.toISOString(),
        breakTime,
        dailyTask: updatedDailyTasks,
        tomorrowTask,
        notes: notesList.length ? notes : [],
        overtTime: overtime === '00:00:00' ? null : overtime,
      })
      .then(() => {
        message.success('Attendance recorded successfully.');
        dispatch(markOut())

        setTimeout(() => {
          // resetLocalStorageAfterAttendance(); // clears your stored state
          localStorage.clear()
          window.location.reload();
        }, 10000); // 5 seconds delay
      })
      .catch(() => {
        dispatch(markOut())
        message.error('Attendance failed');
        // if (overtime) {
        //   localStorage.clear();
        //   window.location.href = "/";
        // }
      });
  }


  const fetchPermissions = async () => {
    try {
      setLoading(true);

      // Make API call to get current permissions and role info
      const response = await axios.get('/getCurrentPermissionsWithRoleInfo');
      if (response.data.success) {
        // Get current user data from localStorage
        const currentUserData = JSON.parse(localStorage.getItem('auth')) || {};

        // Update with new roleInfo and permissions
        const updatedUserData = {
          ...currentUserData,
          roleInfo: response.data.result.roleInfo,
          permissions: response.data.result.permissions,
          photo:response.data?.result?.photo,
        };

        // Save updated data back to localStorage
        localStorage.setItem('auth', JSON.stringify(updatedUserData));

        // Optional: Update state if you're using context or state management
        // setUser(updatedUserData);

        console.log('Permissions updated successfully');
      }
    } catch (error) {
      console.error('Error fetching permissions:', error);
      // Handle error appropriately
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPermissions();
  }, []);


  return (
    <Suspense fallback={<PageLoader />}>
      <AnimatePresence exitBeforeEnter initial={false}>
        {
          timeOut ? null :
            <ShiftManagementApp setOverTime={setOverTime} markTimeOut={ConfirmTimeOut} timeIn={timeIn} />
        }
        {
          currentAdmin?.trackingType == 'hourly' && attendanceStatus ?
            <GenerateEnergySound /> : null
        }
        <Switch location={location} key={location.pathname}>

          {filteredRoutes.map((routeItem) => (
            <PrivateRoute
              key={routeItem.component}
              path={routeItem.path}
              exact={routeItem.exact || true}
              component={lazy(() =>
                import(`@/pages/${routeItem.component}`)
              )}
            />
          ))}
          {/* ✅ Make reset-password public */}
          <Route path="/reset-password/:token" component={ResetPasswordScreen} />

          <PublicRoute path="/login" render={() => <Redirect to="/" />} exact />
          <Route component={Logout} path="/logout" exact />
          <Route path="/url/:id" component={URL} />
          <Route path="*" component={NotFound} render={() => <Redirect to="/notfound" />} />
        </Switch>
      </AnimatePresence>
    </Suspense>
  );
}